export const features = [
  {
    icon: "ri-search-line",
    title: "Browse Products Easily",
    description: "Quickly scan through hundreds of organized product listings without the clutter of traditional marketplaces.",
  },
  {
    icon: "ri-scales-3-line",
    title: "Compare Prices Instantly",
    description: "Side-by-side product comparison lets you spot the best deals across multiple sellers in seconds.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Faster Ordering System",
    description: "Copy product links into the spreadsheet and submit orders to your agent with minimal friction.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Reduce Mistakes",
    description: "Structured data entry eliminates typos and miscommunication, cutting down ordering errors significantly.",
  },
  {
    icon: "ri-filter-3-line",
    title: "Filter Listings",
    description: "Narrow down results by category, price range, and supplier to find exactly what you are looking for.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Improve Efficiency",
    description: "Streamline your entire shopping workflow from discovery to delivery with one organized system.",
  },
];